import { Col, Row, Steps } from "antd";
import { FC, lazy, Suspense, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useNavigate, useSearchParams } from "react-router-dom";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { getAdvertDetails } from "apps/RealState/Details/Services";
import {
  handleResetAllAdvertState,
  handleSetAdData,
  handleSetAdType,
  handleSetDoneSteps,
} from "../ClientSideStates";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import NoPerMissionAdvert from "./NoPermissionAdvert";
import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";
import { MazakaButton } from "apps/Common/MazakaButton";
import { PlusOutlined } from "@ant-design/icons";
import PackageListItem from "./Doping/Components/PackgaeListItem";
import DopingListItem from "./Doping/Components/DopingListItem";
import ValidateUserEIDSCode from "./ValidateUserEIDS";


const SelectCategory = lazy(() => import("./SelectCategory"));
const AdressInfoes = lazy(() => import("./AddresInfoes"));
const AdDetails = lazy(() => import("./AdDetailsIndex"));
const Preview = lazy(() => import("./Preview"));
const Dopping = lazy(() => import("./Doping/Doping"));
const BodyReportIndex = lazy(() => import("./BodyReport/BodyReportIndex"));
const AddOrUpdateFileUpload = lazy(
  () => import("./Media/Components/AddOrUpdateFile")
);
const AddOrUpdateContactTypes = lazy(() => import("./AddOrUpdateContactTypes"));
const Payment = lazy(() => import("./Payment/Payment"));

const StepsIndex: FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [steps, setSteps] = useState<any[]>([]);
  const { adType: type, doneSteps } = useSelector(
    (state: RootState) => state.ad
  );
  const navigate = useNavigate();
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const savedCurrentStep = searchParams.get("currentStep");
  const isRedirectEIDS = searchParams.get("isRedirectEIDS");
  const dispatch = useDispatch();
  const [advertDetailsData, setAdvertDetailsData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  let isShowBodyReport = false;
  

  const getAdvertDetailInfoes = async (advertId: string) => {
    setIsLoading(true);
    try {
      const response = await getAdvertDetails(advertId);

      const type = response?.data?.type;
      let breadcrumbDataforBody = response?.data?.categoryCombinedKey;
        const parts = breadcrumbDataforBody?.split("_") || [];
        if(parts[1] === "5278" || parts[1] === "2" ){
         isShowBodyReport = true;
        }
      console.log(response)

      if (type === 0) {
        dispatch(handleSetAdType({ type: "realState" }));
        dispatch(handleSetDoneSteps({ data: [0, 1, 2, 3, 4, 5, 6] }));
      
      } else if (type === 1) {
        dispatch(handleSetAdType({ type: "vehicle" }));
        dispatch(handleSetDoneSteps({ data: [0, 1, 2, 3, 4, 5, 6, 7] }));
      }
      setAdvertDetailsData(response?.data);
      dispatch(handleSetAdData({ data: response?.data }));
      if (savedCurrentStep) {
        setCurrentStep(Number(savedCurrentStep +1) || 0);
      }
    } catch (error: any) {
      openNotificationWithIcon(
        "error",
        error?.message || "İlan detayları alınamadı"
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (advertId) {
      getAdvertDetailInfoes(advertId);
    }
  }, [advertId]);

  useEffect(() => {
    if (isRedirectEIDS) {
      setCurrentStep(1);
    }
  }, [isRedirectEIDS]);

  useEffect(() => {
  console.log('Current step changed:', currentStep, 'Type:', type, 'Done steps:', doneSteps);
}, [currentStep, type, doneSteps]);


  useEffect(() => {
    let realStatesteps = [
      { title: "Kategori Seçimi" },
      { title: "İlan Detayı" },
      { title: "Resim Ekle" },
      { title: "Adres Detayı" },
      { title: "İletişim Tercihi" },
      { title: "Ön İzleme" },
      { title: "Paketler" },
      { title: "Doping" },
      { title: "Ödeme" },
    ];
    let vehicleSteps = [
      { title: "Kategori Seçimi" },
      { title: "İlan Detayı" },
      { title: "Boya,Değişen Bilgisi" },
      { title: "Resim Ekle" },
      { title: "Adres Detayı" },
      { title: "İletişim Tercihi" },
      { title: "Ön İzleme" },
      { title: "Paketler" },
      { title: "Doping" },
      { title: "Ödeme" },
    ];
    if (type === "realState") {
      setSteps(realStatesteps);
    } else if (type === "vehicle") {
      setSteps(vehicleSteps);
    }
  }, [type, advertDetailsData]);

  const getStepStatus = (index: number) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // veya 'auto'
    });
    if (index === currentStep) {
      return "process";
    }
    if (doneSteps.includes(index)) {
      return "finish";
    }
    return "wait";
  };

  useEffect(() => {
    if (!type) {
      setCurrentStep(0);
    }
  }, [type]);

  const renderStepContent = () => {
    return (
      <Col xs={24} className="">
        <>
          {userInfoes?.userType !== 3 ||
          (userInfoes?.userType === 3 && userInfoes?.storePortfolioUser?.some((x: { isAuthPostAdvert: boolean }) => x.isAuthPostAdvert)) ? (
            <>
              {(() => {
                switch (type) {
                  case "vehicle":
                    switch (currentStep) {
                      case 0:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <SelectCategory setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );

                      case 1:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AdDetails setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );
                      case 2:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <BodyReportIndex setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );                   
                      case 3:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AddOrUpdateFileUpload
                              setCurrentStep={setCurrentStep}
                            />
                          </Suspense>
                        );
                      case 4:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AdressInfoes setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );
                      case 5:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AddOrUpdateContactTypes
                              setCurrentStep={setCurrentStep}
                            />
                          </Suspense>
                        );
                      case 6:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <Preview setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );
                      case 7:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                           
                            <PackageListItem setCurrentStep={setCurrentStep} pageType="advert" />
                          </Suspense>
                        );
                        case 8:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                           
                            <DopingListItem setCurrentStep={setCurrentStep} type="ad"/>
                          </Suspense>
                        );
                      case 9:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <Payment type="advert" />
                          </Suspense>
                        );
                      default:
                        return null;
                    }
                  case "realState":
                  default:
                    switch (currentStep) {
                      case 0:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <SelectCategory setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );

                      case 1:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AdDetails setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );

                      case 2:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AddOrUpdateFileUpload
                              setCurrentStep={setCurrentStep}
                            />
                          </Suspense>
                        );
                      case 3:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AdressInfoes setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );
                      case 4:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <AddOrUpdateContactTypes
                              setCurrentStep={setCurrentStep}
                            />
                          </Suspense>
                        );
                      case 5:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <Preview setCurrentStep={setCurrentStep} />
                          </Suspense>
                        );
                      case 6:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                           <PackageListItem setCurrentStep={setCurrentStep} pageType="advert" />
                          </Suspense>
                        );
                        case 7:
                          return (
                            <Suspense fallback={<GeneralLoadingSpinner />}>
                           <DopingListItem setCurrentStep={setCurrentStep} type="ad"/>
                            </Suspense>
                          );
                      case 8:
                        return (
                          <Suspense fallback={<GeneralLoadingSpinner />}>
                            <Payment type="advert" />
                          </Suspense>
                        );

                      default:
                        return null;
                    }
                }
              })()}
            </>
          ) : (
            <>
              <NoPerMissionAdvert />
            </>
          )}
        </>
      </Col>
    );
  };

  return (
    <>
      <CountinueOnMobileApp isShowDesc isShowChildren={false}>
        {isLoading ? (
          <>
            <GeneralLoadingSpinner />
          </>
        ) : (
          <>
          

            <Col span={24} className="!px-16 !mt-4 ">
              <Row gutter={[0, 20]}>
                {advertDetailsData && (
                  <Col xs={24} className="!flex justify-end ">
                    <MazakaButton
                      type="primary"
                      className="!bg-black !text-white"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        dispatch(handleResetAllAdvertState());
                        navigate("/admin/panel?activePanelMenu=adManagement");
                        setAdvertDetailsData(null);
                      }}
                    >
                      Yeni İlan Oluştur
                    </MazakaButton>
                  </Col>
                )}
                <Col xs={24} id="ad-management-container">
                  <Steps
                    size="small"
                    current={currentStep}
                    onChange={(step) => {
                      if (
                        doneSteps.includes(step) ||
                        step === doneSteps.length
                      ) {
                        setCurrentStep(step); // Update active step
                      }
                    }}
                  >
                    {steps.map((step, index) => (
                      <Steps.Step
                        key={index}
                        title={step.title}
                        status={getStepStatus(index)} // Dynamically set step status
                        disabled={
                          !doneSteps.includes(index) && index !== currentStep
                        }
                      />
                    ))}
                  </Steps>
                </Col>
              </Row>
            </Col>
         

            <>{renderStepContent()}</>
          </>
        )}
      </CountinueOnMobileApp>
    </>
  );
};

export default StepsIndex;
